// The skill guide: every unlock, done or not, with what it takes. The long-term carrot.
import { Check, Lock } from "lucide-react";
import { useUnlocks } from "../lib/api";
import type { UnlockProgress } from "../lib/types";
import { Chip, Empty } from "./ui";

function requirementText(r: Record<string, unknown>): string {
  const parts: string[] = [];
  if (r.skill_level)
    parts.push(
      Object.entries(r.skill_level as Record<string, number>)
        .map(([s, l]) => `${s} ${l}`)
        .join(", "),
    );
  if (r.total_level) parts.push(`total level ${r.total_level}`);
  if (r.event_count) {
    const ec = r.event_count as { type: string; key?: string; min: number };
    parts.push(
      `${ec.min} ${ec.key ? ec.key.replace("_", " ") : ec.type.split(".")[0] + " sessions"}`,
    );
  }
  if (r.unlock) parts.push(`after ${r.unlock}`);
  return parts.join(" · ");
}

export function Unlocks() {
  const { data, isLoading } = useUnlocks();
  if (isLoading) return <Empty>Loading…</Empty>;
  const list = data ?? [];
  const done = list.filter((u) => u.unlocked_at);
  const todo = list.filter((u) => !u.unlocked_at);
  return (
    <section className="grid gap-2">
      <h2 className="text-lg font-semibold">Unlocks</h2>
      <ul className="card divide-y divide-border">
        {[...todo, ...done].map((u: UnlockProgress) => (
          <li
            key={u.id}
            className={`flex items-start gap-3 px-4 py-3 ${u.unlocked_at ? "opacity-60" : ""}`}
          >
            {u.unlocked_at ? (
              <Check size={16} className="mt-0.5 text-recovery" />
            ) : (
              <Lock size={16} className="mt-0.5 text-ink-mute" />
            )}
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <p className="text-sm font-medium">{u.name}</p>
                <Chip>{u.kind.replace("_", " ")}</Chip>
              </div>
              <p className="text-xs text-ink-soft">{u.blurb}</p>
              {!u.unlocked_at && (
                <p className="mt-0.5 text-xs text-ink-mute">Needs {requirementText(u.requires)}</p>
              )}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
